import React from 'react';

const EditSubjectById = () => {
    return (
        <div>
            BLA BLA
        </div>
    );
};

export default EditSubjectById;